import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Home from "./pages/Home";
import Categories from "./pages/Categories";
import CategoryDetail from "./pages/CategoryDetail";
import ProductDetail from "./pages/ProductDetail";
import OpeningGuide from "./pages/OpeningGuide";
import OpeningGuideStep from "./pages/OpeningGuideStep";
import RoomTypes from "./pages/RoomTypes";
import RoomTypeDetail from "./pages/RoomTypeDetail";
import CalculatorPage from "./pages/Calculator";
import ComparisonPage from "./pages/Comparison";
import Contact from "./pages/Contact";
import About from "./pages/About";
import BlogList from "./pages/BlogList";
import BlogDetail from "./pages/BlogDetail";
import NotFound from "./pages/NotFound";
import KVKK from "./pages/KVKK";
import CookieConsent from "./components/CookieConsent";

import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminProducts from "./pages/admin/AdminProducts";
import AdminCategories from "./pages/admin/AdminCategories";
import AdminSlideshow from "./pages/admin/AdminSlideshow";
import AdminQuotes from "./pages/admin/AdminQuotes";
import AdminOpeningGuide from "./pages/admin/AdminOpeningGuide";
import AdminRoomTypes from "./pages/admin/AdminRoomTypes";
import AdminBlog from "./pages/admin/AdminBlog";
import AdminEquipmentFormulas from "./pages/admin/AdminEquipmentFormulas";
import AdminUsers from "./pages/admin/AdminUsers";
import AdminSettings from "./pages/admin/AdminSettings";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/kategoriler" element={<Categories />} />
          <Route path="/kategori/:slug" element={<CategoryDetail />} />
          <Route path="/urun/:slug" element={<ProductDetail />} />
          <Route path="/acilis-rehberi" element={<OpeningGuide />} />
          <Route path="/acilis-rehberi/:slug" element={<OpeningGuideStep />} />
          <Route path="/oda-tipleri" element={<RoomTypes />} />
          <Route path="/oda-tipleri/:slug" element={<RoomTypeDetail />} />
          <Route path="/hesaplama" element={<CalculatorPage />} />
          <Route path="/karsilastirma" element={<ComparisonPage />} />
          <Route path="/blog" element={<BlogList />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          <Route path="/kvkk" element={<KVKK />} />
          <Route path="/iletisim" element={<Contact />} />
          <Route path="/hakkimizda" element={<About />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="products" element={<AdminProducts />} />
            <Route path="categories" element={<AdminCategories />} />
            <Route path="slideshow" element={<AdminSlideshow />} />
            <Route path="opening-guide" element={<AdminOpeningGuide />} />
            <Route path="room-types" element={<AdminRoomTypes />} />
            <Route path="formulas" element={<AdminEquipmentFormulas />} />
            <Route path="blog" element={<AdminBlog />} />
            <Route path="users" element={<AdminUsers />} />
            <Route path="settings" element={<AdminSettings />} />
            <Route path="quotes" element={<AdminQuotes />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
        <CookieConsent />
      </BrowserRouter>
    </div>
  );
}

export default App;
